import apiClient from './apiClient';

export interface UnproductivityRow {
  date: string;
  activityName: string;
  subActivity: string | null;
  cause: string;
  observation: string | null;
}

/**
 * Obtiene las improductividades (torres con avance 0% y motivo) de un proyecto.
 * Solo considera reportes finalizados. Una fila por registro de torre.
 */
export const getConsolidatedUnproductivity = async (projectId: number): Promise<UnproductivityRow[]> => {
  const response = await apiClient.get(`/ConsolidatedUnproductivity/${projectId}`);
  return response.data;
};
